import { withTranslation } from "react-i18next";
import { Button, Input, Label, Modal, ModalBody, ModalHeader, Spinner,  } from "reactstrap";
import GroupedFieldsAccordion from "./GroupedFieldsAccordion";
import { useState } from "react";
import { isJson } from "utils";

const SectionsArrrangeModal = ({ props, steps, setSteps, model, show, onCloseClick,  onChange, loading }: any) => {
    const [viewname, setViewname] = useState<string>("");
    const [error, setError] = useState(false);
    const [fields, setFields]  = useState<any>([])

    const onApply = () => {
        onChange(fields, viewname)
        setViewname("")
    }
    return (
        <Modal backdrop="static" size='xl' className='modal-fullscreen' isOpen={show} toggle={onCloseClick} centered={true}>
                <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                    <span className='text-light'>{props.t("common.modals.create_view")}</span>
                </ModalHeader>
                <ModalBody className='text-center p-5'>
                    <div className="vstack gap-1 py-2 text-left">
                            <Label>
                                View Name <span className="fw-bold text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control w-100"
                                placeholder="Enter View name"
                                value={viewname}
                                onChange={(e: any) => setViewname(e.target.value)}
                            />
                            {error && (
                                <p className="text-danger p-1">View with same name already exists</p>
                            )}
                    </div>
                    <GroupedFieldsAccordion
                        steps={steps}
                        onReorder={setSteps}
                        setFields={setFields}
                    />
                </ModalBody>

                <div className="offcanvas-footer bg-opacity-10 border-top p-3 justify-content-center hstack gap-2">
                    <Button
                        className="btn btn-success w-auto"
                        onClick={() => onApply()}
                        disabled={!viewname || error || loading}
                    >
                        {loading ? <Spinner size="sm" className="flex-shrink-0">Loading... </Spinner> :  null}
                        <span className='text-light'>{props.t("common.modals.create_view")}</span>
                    </Button>
                </div>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(SectionsArrrangeModal);